import { DollarSign, Loader2 } from 'lucide-react'
import { useCost } from '../hooks/useCost'

// Compact daily-spend widget rendered in the navbar. Polls every 60s.
// Color-coded by budget usage so admin sees at a glance when spend is climbing.
// Silently hidden for team role — this is admin-only info.
export function CostWidget() {
  const { data, loading, role } = useCost()

  if (role !== 'admin') return null
  if (loading || !data) {
    return (
      <div className="hidden md:flex items-center gap-1.5 rounded-lg border border-white/5 bg-white/5 px-3 py-2 text-xs text-dark-400">
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
        <span>—</span>
      </div>
    )
  }
  if (!data.enabled) return null

  const today = data.today ?? { total: 0, limit: 0, percentage: 0 }
  const pct = today.percentage
  const tone =
    pct >= 80 ? 'border-red-500/40 bg-red-500/10 text-red-300'
    : pct >= 50 ? 'border-yellow-500/40 bg-yellow-500/10 text-yellow-300'
    : 'border-green-500/40 bg-green-500/10 text-green-300'

  return (
    <div
      className={`hidden md:flex items-center gap-1.5 rounded-lg border px-3 py-2 text-xs font-medium ${tone}`}
      title={`Today: $${today.total.toFixed(4)} / $${today.limit.toFixed(2)} (${pct.toFixed(1)}%)\nMonth: $${(data.month?.total ?? 0).toFixed(4)} / $${(data.month?.limit ?? 0).toFixed(2)}`}
    >
      <DollarSign className="h-3.5 w-3.5" />
      <span>
        {today.total.toFixed(3)}
        <span className="opacity-60"> / {today.limit.toFixed(0)}</span>
      </span>
    </div>
  )
}
